module.exports = __webpack_public_path__ + "img/potencia_r_a.efa28967.svg";